import React from 'react';
import Chart from 'react-apexcharts';

function HeatmapChart({props}: any) {

    const {mode} = props;

    const options = {
        plotOptions: {
            heatmap: {
                shadeIntensity: 0.5,
                radius: 0,
                useFillColorAsStroke: true,
                colorScale: {
                    ranges: [
                        {
                            from: 0,
                            to: 20,
                            name: 'Very Low',
                            color: '#b7ad6c'
                        },
                        {
                            from: 21,
                            to: 40,
                            name: 'Low',
                            // color: '#00A100'
                            color: '#c5b524'
                        },
                        {
                            from: 41,
                            to: 70,
                            name: 'Medium',
                            // color: '#FFB200'
                            color: '#fae700'
                        },
                        {
                            from: 71,
                            to: 100,
                            name: 'High',
                            // color: '#FF0000'
                            color: '#897e1a'
                        }
                    ]
                }
            }
        },
        dataLabels: {
            enabled: true,
            style: {
                colors: mode === 'dark' ? ['#000'] : ['#000']
            },
            formatter: function (val: any, opt: any) {
                return val + '%';
            },
        },
        stroke: {
            width: 1
        },
        legend: {
            labels: {
                colors: mode === 'dark' ? '#fff' : '#000',
            },
        },
        xaxis: {
            labels: {
                style: {
                    colors: mode === 'dark' ? ['#fff', '#fff', '#fff', '#fff', '#fff'] : ['#000', '#000', '#000', '#000', '#000']
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: mode === 'dark' ? ['#fff', '#fff', '#fff', '#fff', '#fff'] : ['#000', '#000', '#000', '#000', '#000']
                }
            }
        },
        tooltip: {
            enabled: false,
        }
    };

    const series = [
        {
            name: 'Agent 1',
            data: [
                { x: 'Wallet Sizing', y: 13 },
                { x: 'Card Usage', y: 37 },
                { x: 'Alternative Payment', y: 40 },
                { x: 'Vendor/Merchants', y: 72 },
                { x: 'Competitor', y: 90 },
            ],
        },
        {
            name: 'Agent 2',
            data: [
                { x: 'Wallet Sizing', y: 23 },
                { x: 'Card Usage', y: 67 },
                { x: 'Alternative Payment', y: 50 },
                { x: 'Vendor/Merchants', y: 32 },
                { x: 'Competitor', y: 45 },
            ],
        },
        {
            name: 'Agent 3',
            data: [
                { x: 'Wallet Sizing', y: 15 },
                { x: 'Card Usage', y: 89 },
                { x: 'Alternative Payment', y: 56 },
                { x: 'Vendor/Merchants', y: 45 },
                { x: 'Competitor', y: 78 },
            ],
        },
        {
            name: 'Agent 4',
            data: [
                { x: 'Wallet Sizing', y: 64 },
                { x: 'Card Usage', y: 22 },
                { x: 'Alternative Payment', y: 77 },
                { x: 'Vendor/Merchants', y: 34 },
                { x: 'Competitor', y: 59 },
            ],
        },
        {
            name: 'Agent 5',
            data: [
                { x: 'Wallet Sizing', y: 33 },
                { x: 'Card Usage', y: 48 },
                { x: 'Alternative Payment', y: 92 },
                { x: 'Vendor/Merchants', y: 56 },
                { x: 'Competitor', y: 20 },
            ],
        },
        {
            name: 'Agent 6',
            data: [
                { x: 'Wallet Sizing', y: 21 },
                { x: 'Card Usage', y: 14 },
                { x: 'Alternative Payment', y: 84 },
                { x: 'Vendor/Merchants', y: 70 },
                { x: 'Competitor', y: 67 },
            ],
        },
        {
            name: 'Agent 7',
            data: [
                { x: 'Wallet Sizing', y: 45 },
                { x: 'Card Usage', y: 36 },
                { x: 'Alternative Payment', y: 50 },
                { x: 'Vendor/Merchants', y: 81 },
                { x: 'Competitor', y: 33 },
            ],
        },
        {
            name: 'Agent 8',
            data: [
                { x: 'Wallet Sizing', y: 71 },
                { x: 'Card Usage', y: 19 },
                { x: 'Alternative Payment', y: 66 },
                { x: 'Vendor/Merchants', y: 43 },
                { x: 'Competitor', y: 95 },
            ],
        },
        {
            name: 'Agent 9',
            data: [
                { x: 'Wallet Sizing', y: 88 },
                { x: 'Card Usage', y: 24 },
                { x: 'Alternative Payment', y: 39 },
                { x: 'Vendor/Merchants', y: 28 },
                { x: 'Competitor', y: 76 },
            ],
        },
        {
            name: 'Agent 10',
            data: [
                { x: 'Wallet Sizing', y: 59 },
                { x: 'Card Usage', y: 42 },
                { x: 'Alternative Payment', y: 30 },
                { x: 'Vendor/Merchants', y: 84 },
                { x: 'Competitor', y: 65 },
            ],
        },
        {
            name: 'Agent 11',
            data: [
                { x: 'Wallet Sizing', y: 12 },
                { x: 'Card Usage', y: 91 },
                { x: 'Alternative Payment', y: 47 },
                { x: 'Vendor/Merchants', y: 22 },
                { x: 'Competitor', y: 34 },
            ],
        },
        {
            name: 'Agent 12',
            data: [
                { x: 'Wallet Sizing', y: 54 },
                { x: 'Card Usage', y: 17 },
                { x: 'Alternative Payment', y: 95 },
                { x: 'Vendor/Merchants', y: 78 },
                { x: 'Competitor', y: 44 },
            ],
        },
        {
            name: 'Agent 13',
            data: [
                { x: 'Wallet Sizing', y: 29 },
                { x: 'Card Usage', y: 33 },
                { x: 'Alternative Payment', y: 83 },
                { x: 'Vendor/Merchants', y: 69 },
                { x: 'Competitor', y: 52 },
            ],
        },
        {
            name: 'Agent 14',
            data: [
                { x: 'Wallet Sizing', y: 66 },
                { x: 'Card Usage', y: 75 },
                { x: 'Alternative Payment', y: 18 },
                { x: 'Vendor/Merchants', y: 91 },
                { x: 'Competitor', y: 27 },
            ],
        },
        {
            name: 'Agent 15',
            data: [
                { x: 'Wallet Sizing', y: 40 },
                { x: 'Card Usage', y: 54 },
                { x: 'Alternative Payment', y: 28 },
                { x: 'Vendor/Merchants', y: 39 },
                { x: 'Competitor', y: 86 },
            ],
        },
    ];

    return (
        <Chart options={options} series={series} type="heatmap" height={650} />
    );
};

export default HeatmapChart;